import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  PortalRepo, usePortal, usePortalContext, portalDetailPath, portalContextPath,
  type PortalContextDraft,
} from './olivium/portal-factory'

/**
 * Portal repo/deployment editor route wrapper (PHASE_2L).
 *   /square/command-center/olivium/portals/:portalId/repo
 *
 * Owns usePortalContext; saving upserts sq_project_portal_context (real). Live
 * GitHub sync + permission automation are honestly deferred in the surface.
 */
export default function SquareCodePortalRepoRoute() {
  const navigate = useNavigate()
  const { portalId } = useParams<{ portalId: string }>()
  const id = portalId || ''
  const portal = usePortal(portalId)
  const ctx = usePortalContext(portalId)
  const [saving, setSaving] = useState(false)

  const onSave = async (fields: PortalContextDraft) => {
    setSaving(true)
    try { await ctx.save(fields) } finally { setSaving(false) }
  }

  return (
    <PortalRepo
      portalName={portal.detail?.portal.project_name}
      context={ctx.context}
      loading={ctx.loading}
      error={ctx.error}
      authRequired={ctx.authRequired}
      saving={saving}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onOpenPortal={() => navigate(portalDetailPath(id))}
      onOpenContext={() => navigate(portalContextPath(id))}
      onSave={onSave}
    />
  )
}
